import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export function useAddCandidateSkill() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, skill }) => {
      return axios.post(`/candidate/${candidate.uuid}/skill`, {
        ...skill,
      });
    },
    onSuccess: (response, variables) => {
      // The body is the candidate plus `added_skill`, the skill this request
      // attached; only the candidate belongs in its cache.
      const candidate = { ...response?.data };
      delete candidate.added_skill;
      client.setQueryData(["candidateDetails", variables.candidate.uuid], { ...response, data: candidate });
    },
  });
}

export function useRemoveCandidateSkill() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationFn: ({ candidate, skillId }) => {
      return axios.delete(`/candidate/${candidate.uuid}/skill`, {
        data: {
          skill_id: skillId,
        },
      });
    },
    onSuccess: (data, variables) => {
      client.setQueryData(["candidateDetails", variables.candidate.uuid], data);
    },
  });
}
